export default {
  returnProduct: 'Returnera produkt',
  returnOrder: 'Returnera order',
  introduction:
    'Skulle du behöva returnera eller reklamera en produkt så rekommenderar vi att du besöker en butik. Om du inte har möjlighet att gå till någon av våra butiker, fyll i ordernummer och postnummer för att skicka in din retur. Läs gärna mer om våra generösa villkor för garanti och öppet köp nedan. Här kan du hitta din närmsta butik eller fylla i formuläret online.',
  searchStoreDescription:
    'Du vet väl att du även kan returnera eller reklamera din vara i någon av våra butiker? Sök här nedan för att hitta din butik.',
  searchStoreTitle: 'Gör din retur i butik',
  searchStoreLabel: 'Butiksnamn eller ort',
  searchStoreButton: 'Hitta din butik',
  searchOrderTitle: 'Skicka in din retur',
  searchOrderDescription:
    'Vi har en enkel process för att göra returer online, fyll i ordernummer och postnummer för att komma vidare.',
  orderNumber: 'Ordernummer',
  postCode: 'Postnummer',
  findOrder: 'Hitta order',
  errorNumbersOnly: 'Endast siffror är tillåtna i postnummer.',
  errorPostCodeFiveChars: 'Postnummer måste bestå av 5 tecken',
  orderError: 'Kunde inte hitta din order.',
  orderErrorPart1: 'Vi kunde inte hitta din order. Ta kontakt med vår ',
  orderErrorPart2: 'https://www.clasohlson.com/se/contact-us',
  orderErrorPart3: 'kundservice',
  orderErrorPart4: ' för att gå vidare med din retur.',
  loginBtnText: 'Eller logga in och välj order',
  termsTitle: 'Detta är våra köpvillkor',
  termsDescription:
    'Vi har lång erfarenhet av att vilja tillhandage god service till våra kunder och därför har vi även fokuserat på att ha bra köpvillkor för dig som kund. Klicka på någon av kategorierna nedan för att läsa mer.',
  generalError: 'Något fick fel.',
  deleteRowConfirm: 'Är du säker på att du vill ta bort denna artikel från din retur?',
  stepOneTitle: 'Välj de produkter du vill returnera genom att klicka på dom',
  stepTwoTitle: 'Välj åtgärder för dom produkter du valt',
  stepThreeTitle: 'Du är nu redo att skicka in din förfrågan!',
  goBack: 'Gå tillbaka',
  send: 'Skicka returförfrågan',
  returnSentTitle: 'Din förfrågan är skickad!',
  returnSentDescription:
    'Vår kundservice hör av sig inom ca 48 timmar med ytterligare instruktioner gällande din förfrågan.',
  returnSentCloseBtn: 'Okej, fortsätt handla',
  returnNotSentTitle: 'Något gick fel.',
  returnNotSentDescription:
    'Försök skicka din order på nytt. Om felet kvarstår, var vänlig kontakta vår kundtjänst.',
  returnNotSentCloseBtn: 'Stäng',
  productsInOrder: 'Produkter i denna beställning',
  productsSelected: 'produkt(er) valda',
  continue: 'Nästa steg',
  contactTitle: 'Har du frågor gällande din retur?',
  contactDescription: 'Kontakta kundcervice så hjälper vi dig',
  contactBtn: 'Kontakta oss',
  orderHeaderDescription:
    'Vi har hittat din order och listar de produkter som ingick i beställningen nedan. Fyll i de produkter och antal du önskar returnera, så återkommer vår kundtjänst med returfraktsedel eller alternativ åtgärd.',
  orderHeaderDescriptionContinue: 'för att hitta din närmsta butik.',
  clickHere: 'Klicka här',
  orderNo: 'Order nr.',
  date: 'Datum',
  products: 'Produkter',
  amount: 'Summa',
  status: 'Status',
  artNr: 'Art. nr',
  incVat: 'Inkl. moms',
  product: 'Produkt',
  numberOfItems: 'Antal',
  reasonForReturn: 'Returåtgärd',
  selectReason: 'Välj en returåtgärd',
  Reklamation: 'Reklamation',
  'Öppet köp': 'Öppet köp',
  selectAction: 'Vilka orsaker är anledningen till att du vill reklamera din vara? ',
  selectActionOpenPurchase: 'Vilka orsaker är anledningen till att du vill returnera din vara? ',
  mustSelectOneReason: 'Du måste välja minst en av orsakerna nedan',
  'Trasig vara': 'Trasig vara',
  Transportvara: 'Transportskada',
  'Fellevererad vara': 'Fellevererad vara',
  Annat: 'Annat',
  'Fel produkt': 'Fel produkt',
  'Fel storlek': 'Fel storlek',
  'Fel färg': 'Fel färg',
  additionalInformation: 'Ytterligare information',
  processOneTitle: 'Öppet köp',
  processOneDescription: 'Utnyttja öppet köp i upp till 365 dagar',
  processTwoTitle: 'Returnera',
  processTwoDescription: 'Regler för att returnera av varor',
  processThreeTitle: 'Återbetalningar',
  processThreeDescription: 'Återbetalning utan onödigt dröjsmål',
  processFourTitle: 'Garanti',
  processFourDescription: 'Minst 2 års garanti på alla våra produkter',
  mustEnterNotes:
    'Fyll i fältet nedan med ytterligare information varför du önskar reklamera din vara.',
  returnProductError: 'Denna produkt kan ej returneras',
  fetchingOrderLabel: 'Hämtar order...',
  email: 'Epostadress',
  name: 'Namn',
  privacyStatementText: 'Läs mer om hur vi behandlar dina personuppgifter.',
  privacyStatementLinkLabel: 'Privacy statement',
  privacyStatementLink: 'https://www.clasohlson.com/se/privacy-statement-contact',
  dateFormat: 'yyyy-MM-dd',
  noReturnQtyMessage:
    'Var vänlig fyll i antal för de produkter du vill returnera för att gå vidare',
};
